export enum MembersPageType {
  Details,
  Requests,
}

export enum MemberFilterTypes {
  Query = 'query',
  Section = 'section',
  Entity = 'entity',
  ProfileTypes = 'profileTypes',
}
